export function runWhenIdle(callback: () => void, timeout = 1500): () => void {
  if (typeof window === 'undefined') return () => {};

  let cancelled = false;
  const run = () => {
    if (!cancelled) callback();
  };

  if ('requestIdleCallback' in window) {
    const id = (window as any).requestIdleCallback(run, { timeout });
    return () => {
      cancelled = true;
      if ('cancelIdleCallback' in window) {
        (window as any).cancelIdleCallback(id);
      }
    };
  }

  const id = window.setTimeout(run, timeout);
  return () => {
    cancelled = true;
    window.clearTimeout(id);
  };
}
